import { render, staticRenderFns } from "./NoteCard.vue?vue&type=template&id=acce5240&scoped=true"
import script from "./NoteCard.vue?vue&type=script&lang=js"
export * from "./NoteCard.vue?vue&type=script&lang=js"
import style0 from "./NoteCard.vue?vue&type=style&index=0&id=acce5240&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acce5240",
  null
  
)

export default component.exports